<script setup lang="ts">
import AppImage from '@/components/shared/AppImage.vue';
</script>

<template>
  <div class="mt-20 flex flex-row! items-center">
    <div class="grow *:h-3 *:w-full">
      <div class="bg-brand-dark-red" />
      <div class="bg-white" />
      <div class="bg-brand-green" />
    </div>
    <AppImage name="figure-bug" alt="" sizes="40px" />
    <div class="grow *:h-3 *:w-full">
      <div class="bg-brand-dark-red" />
      <div class="bg-white" />
      <div class="bg-brand-green" />
    </div>
  </div>
</template>
